import {
  addDays,
  getStringWeekDaysStartingFromDate,
} from "../../../../../../utils/dateUtils";
import { Scheduling } from "../../../../../../models/schedule";
import useMediaQuery from '@mui/material/useMediaQuery';

import { useDealershipConsultantWeekSchedule } from "../../../../../../hooks/useDealershipConsultantSchedule";

interface IWeekProps {
  firstWeekDay: Date;
  currentDate: Date;
  consultantMonthSchedule: Scheduling[];
  handleScheduling: (scheduling: Scheduling) => void;
}

const Week = ({
  firstWeekDay,
  currentDate,
  consultantMonthSchedule,
  handleScheduling,
}: IWeekProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { getScheduleTask } = useDealershipConsultantWeekSchedule(
    firstWeekDay,
    consultantMonthSchedule,
    handleScheduling
  );

  const timeSlots = Array.from({ length: 24 * 2 }).map((_, index) => {
    const hour = Math.floor(index / 2);
    const minute = index % 2 === 0 ? 0 : 30;
    return { hour, minute };
  });

  return (
    <div className={isMobile ? "mobile-week-container" : ""}>
      <table className="width-100pct table-fixed">
        <thead>
          <tr>
            <th className="width-60 height-20"></th>
            {getStringWeekDaysStartingFromDate(firstWeekDay).map((day, index) => (
              <th
                className={`height-20 text-medium ${
                  currentDate.getDate() === firstWeekDay.getDate() + index
                    ? "bg-highlight-lighter border"
                    : ""
                } ${isMobile ? "mobile-week-header" : ""}`}
                key={index}
              >
                {isMobile ? day.substring(0, 3) : day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map(({ hour, minute }, rowIndex) => (
            <tr key={rowIndex}>
              <td className="display-flex justify-content-center align-items-center">
                {`${hour.toString().padStart(2, "0")}:${minute
                  .toString()
                  .padStart(2, "0")}`}
              </td>
              {Array.from({ length: 7 }).map((_, day) => {
                // const availableDateTime = !(
                //   day === 6 ||
                //   (day === 5 && hour > 12)
                // );
                const availableDateTime = true;
                return (
                  <td
                    style={{ 
                      height: isMobile ? 60 : 96, 
                      width: isMobile ? 80 : 100,
                      minWidth: isMobile ? 80 : 100
                    }}
                    className={`border ${
                      !availableDateTime
                        ? "bg-lighter"
                        : currentDate.getDate() === firstWeekDay.getDate() + day
                        ? "bg-highlight-decent"
                        : ""
                    }`}
                    key={day}
                  >
                    {availableDateTime
                      ? getScheduleTask(addDays(firstWeekDay, day), hour, minute)
                      : null}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Week;
